@use '@hevoio/hevo-ui-toolkit/styles/variables' as hevo-toolkit-variables;

.filtersContainer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  // No side padding: the tab's own container already insets this bar, so the
  // 20px here pushed the applied-filter chips and the refresh control in
  // from the content edge. Bottom spacing stays.
  padding: 0 0 hevo-toolkit-variables.$spacer * 0.75;
  min-height: 46px;

  .appliedFiltersContainer {
    flex: 1;
    display: flex;
    align-items: center;
  }

  .filterWrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    .appliedFilter {
      flex: 1;
      overflow: hidden;
      display: flex;
      align-items: center;
    }

    .cloudwatchStatus {
      display: flex;
      align-items: center;
      white-space: pre;

      .editIcon {
        margin-right: -4px;
      }
    }

    .refreshButton {
      margin-right: -4px;
      margin-left: -4px;
    }

    .shimmerBig {
      width: 120px;
      height: 12px;
    }

    .shimmerSmall {
      width: 80px;
      height: 12px;
    }
  }

  &.filtersDialog {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background:  hevo-toolkit-variables.$surface-bg;
    padding: 16px 20px;
  }
}
